import { ComparisonView } from "@/components/aicheck/ComparisonView";
import type { ActiveTab } from "@/components/aicheck/hooks/useTraceabilityHistory";
import type { ProjectDataComparisonResult } from "@/components/aicheck/SourceWorkspace";

interface ComparisonTabProps {
  result: ProjectDataComparisonResult;
  activeTab: ActiveTab;
}

/** 「Comparison」タブ本体。tabpanel ラッパ + ComparisonView。 */
export function ComparisonTab({ result, activeTab }: ComparisonTabProps) {
  return (
    <div
      id="results-panel-comparison"
      role="tabpanel"
      aria-labelledby="results-tab-comparison"
      hidden={activeTab !== "comparison"}
    >
      <ComparisonView result={result} />
    </div>
  );
}
